class Faq {
    constructor() {
        this.$faqs = $('.js-faq');

        this.init();
    }

    init() {
        this.$faqs.on('click', (e) => {
            $(e.currentTarget).toggleClass('open');
        });
    }
}

export default Faq;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/faq.js